import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { KnBrWhatsNewComponent } from './kn-br-whats-new.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        I18nModule,
        BrowserModule,
        MediaModule,
        IconModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleWhatsNewComponent: {
                    component: KnBrWhatsNewComponent,
                },
            },
        } as CmsConfig),
        KnBrWhatsNewComponent,
    ]
})
export class KnBrWhatsNewModule { }
